module.exports = __webpack_public_path__ + "static/media/icon_mesh_on.1672c478.svg";